const searchTerm = ref('');

function setSearchTerm(term) {
  searchTerm.value = term;
}

function useSearchStore() {
  return {
    searchTerm,
    setSearchTerm
  };
}

export default useSearchStore;